export default __webpack_public_path__ + "static/media/cancelModal.0c6961d2.svg";